<template>
  <div class="tab_container">
    <!-- 市场实销 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        市场实销
      </div>
    </div>
    <!-- TOP5车型 市场实销 -->
    <div class="second_title">
      TOP5车型 市场实销
      <el-button
        v-if="$route.query.operateType !== '查看'"
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('top5CarModel')"
        >保存</el-button
      >
    </div>
    <top5-car-model ref="top5CarModel" />
    <!-- 各品牌标杆车型 市场实销 -->
    <div class="second_title">
      各品牌标杆车型 市场实销
      <el-button
        v-if="$route.query.operateType !== '查看'"
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('allBrandCarModel')"
        >保存</el-button
      >
    </div>
    <all-brand-car-model ref="allBrandCarModel" />
  </div>
</template>

<script>
import Top5CarModel from "./top5CarModel.vue";
import AllBrandCarModel from "./allBrandCarModel.vue";
import { getHistorySalesImportApi } from "@/api/saleTaskCollection";

export default {
  components: {
    Top5CarModel,
    AllBrandCarModel
  },
  data() {
    return {};
  },
  created() {
    this.getHistorySalesImport();
  },
  methods: {
    // 获取历史销量导入
    async getHistorySalesImport() {
      try {
        let data = {};
        if (this.$route.query.areaName && this.$route.query.countryName) {
          const res = await getHistorySalesImportApi({
            areaName: this.$route.query.areaName,
            countryName: this.$route.query.countryName
          });
          if (res.status == 0) {
            data = res.data || {};
          } else {
            this.$DonMessage.error(res.message);
          }
        }
        this.$refs.top5CarModel.init(data.saleDataTop5List);
        this.$refs.allBrandCarModel.init(data.saleDataEachList);
      } catch (error) {}
    },
    // 保存
    handleSave(refField) {
      let submitData = {};
      if (refField !== "baseInfo") {
        if (!this.$route.query.baseInfoId) {
          this.$DonMessage.warning("请先保存基础信息")
          return;
        }
        submitData = {
          areaName: this.$route.query.areaName,
          countryName: this.$route.query.countryName
        };
      }
      this.$refs[refField].handleSave(submitData);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
